import { useEffect, useState } from "react";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api } from "../../lib/api";
import { FollowUps } from "./FollowUps";

const STATUS_COLOR = { new: "#38BDF8", contacted: "#F59E0B", approved: "#10B981", onboarded: "#FF6B00", rejected: "#F87171" };

export const Overview = () => {
  const [s, setS] = useState(null);
  const load = () => api.get("/admin/stats").then((r) => setS(r.data)).catch(() => setS(null));
  useEffect(() => {
    load();
  }, []);
  if (!s) return <p className="text-slate-400">Loading…</p>;
  const byStatus = s?.by_status ?? {};
  const byRole = s?.by_role ?? {};

  return (
    <div className="space-y-6" data-testid="admin-overview">
      <FollowUps onChange={load} />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-6">
        <div className="bento col-span-2 bg-saffron text-ink hover:border-transparent" data-testid="stat-total-leads">
          <p className="text-sm font-semibold">Total leads</p>
          <p className="mt-2 font-display text-5xl font-extrabold">{s.total ?? 0}</p>
        </div>
        {Object.entries(byStatus).map(([k, v]) => (
          <div key={k} className="bento" data-testid={`stat-${k}`}>
            <p className="flex items-center gap-2 text-sm capitalize text-slate-300"><span className="h-2 w-2 rounded-full" style={{ background: STATUS_COLOR[k] }} />{k}</p>
            <p className="mt-2 font-display text-3xl font-bold">{v}</p>
          </div>
        ))}
      </div>
      <div className="grid gap-4 lg:grid-cols-3">
        <div className="bento lg:col-span-2">
          <p className="text-sm text-slate-300">New leads · last 14 days</p>
          <div className="mt-4 h-64">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={s.daily ?? []}>
                <defs>
                  <linearGradient id="g" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#FF6B00" stopOpacity={0.5} />
                    <stop offset="100%" stopColor="#FF6B00" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <XAxis dataKey="date" stroke="#94A3B8" fontSize={11} tickLine={false} axisLine={false} />
                <YAxis allowDecimals={false} stroke="#94A3B8" fontSize={11} tickLine={false} axisLine={false} width={28} />
                <Tooltip contentStyle={{ background: "#131C31", border: "1px solid rgba(255,255,255,.1)", borderRadius: 12 }} />
                <Area type="monotone" dataKey="leads" stroke="#FF6B00" strokeWidth={2} fill="url(#g)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bento space-y-6">
          <div>
            <p className="text-sm text-slate-300">By partner type</p>
            {Object.entries(byRole).map(([k, v]) => (
              <div key={k} className="mt-4">
                <div className="flex justify-between text-sm capitalize"><span>{k === "shg" ? "Individual / SHG" : k}</span><span className="font-mono">{v}</span></div>
                <div className="mt-2 h-1.5 rounded-full bg-white/10"><div className="h-full rounded-full bg-emerald" style={{ width: `${s.total ? (v / s.total) * 100 : 0}%` }} /></div>
              </div>
            ))}
          </div>
          <div>
            <p className="text-sm text-slate-300">Top states</p>
            <ul className="mt-3 space-y-2 text-sm">
              {(s.states ?? []).map((x) => (
                <li key={x.state} className="flex justify-between"><span>{x.state}</span><span className="font-mono text-slate-300">{x.count}</span></li>
              ))}
              {!(s.states ?? []).length && <li className="text-slate-400">No data yet</li>}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
